import * as Sentry from '@sentry/react';

import config from '@wearetla/tla-essentials-tools/config';

const integrations = [
	new Sentry.BrowserTracing(),
	// typeof window !== 'undefined' ? new Sentry.Replay : false,
].filter((f) => !!f);

Sentry.init({
	dsn: config.sentry?.dsn,
	integrations: integrations,
	tracesSampleRate: config.sentry?.tracesSampleRate ?? 1.0,
	replaysSessionSampleRate: config.sentry?.replaysSessionSampleRate ?? 0.1,
	replaysOnErrorSampleRate: config.sentry?.replaysOnErrorSampleRate ?? 1.0,
	beforeSend(event, hint) {
		const error = hint.originalException;
		if (error?.message) {
			if (
				error.message.match(
					/Non-Error promise rejection captured with keys: error, success, validation_error/
				)
			) {
				return null;
			}
			if (
				error.message.match(/loading/i) &&
				error.message.match(/chunk/i) &&
				error.message.match(/failed/i)
			) {
				event.fingerprint = ['Chunk error'];
			}
		}
		return event;
	},
	denyUrls: [/extensions\//i, /^ chrome: \/\//i, /maps\.googleapis\.com/i, /cookiebot.com/i],
});

export const SentryProvider = ({ children }) => {
	return children;
};

export default SentryProvider;
